import styled from "@emotion/styled";
var BulletItemContainer = /*#__PURE__*/ styled("li", {
    target: "e1f5aua90"
})("display:flex;flex-direction:row;align-items:flex-start;margin-bottom:0.5rem;gap:0.375rem;svg{flex-shrink:0;margin-top:0.333em;fill:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";}");
var BulletItemContent = /*#__PURE__*/ styled("span", {
    target: "e1f5aua91"
})("font-size:", function(param) {
    var theme = param.theme;
    return theme.fontSize.sm.size;
}, ";line-height:", function(param) {
    var theme = param.theme;
    return theme.fontSize.sm.lineHeight;
}, ";");
export { BulletItemContainer, BulletItemContent };
